WLS = require('../../../../node_modules/widget-layout-assets/coffee/wls')

SharedWidgetLayoutView =

  hideWidgets: ->
    $('.cross-sell-widgets').hide()

  showWidgets: (page_type) ->
    if @isWidgetLayoutEnabled()
      $crossSellWidgetContainer =  $('.cross-sell-widgets')
      $crossSellWidgetContentContainer = $('#cross-sell-widgets-content-container')
      $crossSellWidgetContentContainer.empty()
      if widgetLayoutResponse?.RecentlyViewedDeals?
        $crossSellWidgetContentContainer.html(widgetLayoutResponse.RecentlyViewedDeals)
      if widgetLayoutResponse?.MoreRecommendations?
        $crossSellWidgetContentContainer.append(widgetLayoutResponse.MoreRecommendations)
      switch page_type
        when 'ticket-success'
          $crossSellWidgetContentContainer.removeClass('problem-solved-step')
          $crossSellWidgetContentContainer.addClass('ticket-success-step')
        when 'problem-solved'
          $crossSellWidgetContentContainer.removeClass('ticket-success-step')
          $crossSellWidgetContentContainer.addClass('problem-solved-step')
      $crossSellWidgetContainer.show()
      if window.WLS?.init?
        window.WLS.init()
        $('.lazy-load').lazyload({})


  isWidgetLayoutEnabled: () ->
    (widgetLayoutResponse?.RecentlyViewedDeals?) or (widgetLayoutResponse?.MoreRecommendations?)

module.exports = SharedWidgetLayoutView
